import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vShow as _vShow, Transition as _Transition, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from './assets/brickminidsvideo3_3_1.mp4'
import _imports_1 from './assets/BrickDiagram.png'


const _hoisted_1 = { id: "main-content" }
const _hoisted_2 = { id: "first-splash-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "splash-screen-text" }, [
  /*#__PURE__*/_createTextVNode(" Want to see JWST's view of our "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "Galactic Center?")
], -1)
const _hoisted_4 = { id: "splash-screen-acknowledgements" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.cosmicds.cfa.harvard.edu/",
  target: "_blank",
  rel: "noopener noreferrer"
}, "Cosmic Data Stories", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.worldwidetelescope.org/home/",
  target: "_blank",
  rel: "noopener noreferrer"
}, "WorldWide Telescope", -1)
const _hoisted_7 = { id: "splash-screen-logos" }
const _hoisted_8 = {
  class: "modal",
  id: "modal-loading"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" }),
  /*#__PURE__*/_createElementVNode("p", null, "Loading …")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "top-content" }
const _hoisted_12 = { id: "left-buttons" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { id: "center-buttons" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { id: "right-buttons" }, null, -1)
const _hoisted_15 = {
  key: 0,
  id: "jwst-crossfade"
}
const _hoisted_16 = { class: "bottom-content" }
const _hoisted_17 = { id: "overlay-button-container" }
const _hoisted_18 = {
  key: 0,
  id: "tools"
}
const _hoisted_19 = { class: "tool-container" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "light-type" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "light-type" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Background imagery:", -1)
const _hoisted_25 = ["value"]
const _hoisted_26 = { id: "project-credits" }
const _hoisted_27 = { id: "icons-container" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "error-message" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "This app requires WebGL 2")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, " Check your browser's settings and enable WebGL 2 (\"graphics acceleration\" on some browsers). "),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/_createTextVNode(" You can check whether your browser supports WebGL 2 and get assistance "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://get.webgl.org/webgl2/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "here"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_29 = { class: "video-wrapper" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("video", {
  controls: "",
  id: "info-video"
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/mp4"
  })
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h3", null, "Information", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h3", null, "Using WWT", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h3", null, "About \"The Brick\"", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("em", null, "densest, most massive")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "The background image shows the Milky Way as observed in infrared light by the Spitzer Space Telescope, a predecessor to JWST.", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h3", null, "Seeing in Infrared light", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  id: "brick-diagram",
  alt: "This is a schematic of The Brick as imaged by JWST, separated into layers. The bottom layer depicts light from hot background gas that emits at both longer and shorter IR wavelengths, depicted with red and blue arrows. Above that is The Brick layer. In the middle of The Brick, red and blue arrows from the bottom layer are stopped by The Brick layer. Near the edge of the Brick, the red arrow is stopped, but the blue arrow can pass. Outside of The Brick region, both red and blue arrows can pass. The top of the schematic shows the direction the light moves towards JWST. ",
  src: _imports_1
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, "Our eyes see visible light, but visible light is only a small part of a broader spectrum of light that has different energies, ranging from gamma rays and x-rays to infrared light and radio waves. Blue light corresponds to shorter wavelength (and higher energy) light, while red corresponds to longer wavelength (and lower energy) light. Images from each part of the spectrum can tell a different part of the story about objects in space.", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, "JWST takes pictures in infrared (or IR) light, which is longer than visible light and cannot be seen by our eyes. Astronomers can still assign “false” colors to help us make sense of the images. In  JWST’s images of The Brick, the shorter wavelength IR light is displayed in “blue,” and the longer wavelength IR light is displayed in “red.” Atoms of hot hydrogen gas in the center of our galaxy emit light at both these IR wavelengths.", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, "The dense cloud that makes up “The Brick” is mostly cold hydrogen, dust, and carbon monoxide (CO). The Brick is so dense that it blocks the infrared light emitted by the surrounding hot hydrogen, creating the dark jelly bean shape we see at the center of the JWST images. In the center of the cloud, the dust blocks both the shorter (“blue”) and longer (“red”) IR wavelengths. Towards the edge of the cloud where it is less dense, frozen CO ice does most of the blocking. CO ice tends to block more of the “red” and less of the “blue” IR light, so the edge of the cloud glows “blue”in these images.", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://news.clas.ufl.edu/the-brick-milky-way/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Science"),
  /*#__PURE__*/_createTextVNode(" Team")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Use the bottom slider to switch between the Spitzer and JWST images. "),
  /*#__PURE__*/_createElementVNode("li", null, " Use the top slider to switch between the \"with stars\" and \"no stars\" version of The Brick as seen by JWST. ")
], -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "credits" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Credits"),
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.cosmicds.cfa.harvard.edu/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "CosmicDS"),
    /*#__PURE__*/_createTextVNode(" Team:")
  ]),
  /*#__PURE__*/_createTextVNode(" John Lewis"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Pat Udomprasert"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Jon Carifio"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Alyssa Goodman"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Harry Houghton"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Anna Nolin"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Mary Dussault"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Evaluator: Sue Sunbury"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("h4", null, "WorldWide Telescope Team:"),
  /*#__PURE__*/_createTextVNode(" Peter Williams"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" A. David Weigel"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Jon Carifio"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_57 = {
  id: "user-experience-footer",
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_credit_logos = _resolveComponent("credit-logos")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_places_gallery = _resolveComponent("places-gallery")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_funding_acknowledgement = _resolveComponent("funding-acknowledgement")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_user_experience = _resolveComponent("user-experience")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_cds_privacy_policy = _resolveComponent("cds-privacy-policy")!
  const _component_v_app = _resolveComponent("v-app")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    style: _normalizeStyle(_ctx.cssVars)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_WorldWideTelescope, { "wwt-namespace": _ctx.wwtNamespace }, null, 8, ["wwt-namespace"]),
        _createVNode(_component_v_overlay, {
          "model-value": _ctx.showSplashScreen,
          absolute: "",
          opacity: "0.6",
          style: _normalizeStyle(_ctx.cssVars),
          id: "splash-overlay"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              id: "splash-screen",
              style: _normalizeStyle(_ctx.cssVars)
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_font_awesome_icon, {
                  id: "close-splash-button",
                  onClick: _ctx.closeSplashScreen,
                  icon: "xmark"
                }, null, 8, ["onClick"]),
                _hoisted_3
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_v_btn, {
                  class: "splash-get-started",
                  onClick: _ctx.closeSplashScreen,
                  color: _ctx.accentColor,
                  density: _ctx.xSmallSize ? 'compact' : 'default',
                  size: "x-large",
                  variant: "elevated",
                  rounded: "lg"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Get Started ")
                  ]),
                  _: 1
                }, 8, ["onClick", "color", "density"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(" Brought to you by "),
                _hoisted_5,
                _createTextVNode(" and "),
                _hoisted_6,
                _createTextVNode(". "),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa-grantee'] })
                ])
              ])
            ], 4)), [
              [_directive_click_outside, _ctx.closeSplashScreen]
            ])
          ]),
          _: 1
        }, 8, ["model-value", "style"]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_10, 512), [
              [_vShow, _ctx.isLoading]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_icon_button, {
              modelValue: _ctx.showTextSheet,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showTextSheet) = $event)),
              "fa-icon": "book-open",
              color: _ctx.accentColor,
              "tooltip-text": _ctx.showTextSheet ? 'Hide Info' : 'Learn More',
              "tooltip-location": "start"
            }, null, 8, ["modelValue", "color", "tooltip-text"]),
            _createVNode(_component_icon_button, {
              modelValue: _ctx.showVideoSheet,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
              "fa-icon": "video",
              color: _ctx.accentColor,
              "tooltip-text": "Watch video",
              "tooltip-location": "start"
            }, null, 8, ["modelValue", "color"]),
            _createVNode(_component_icon_button, {
              "md-icon": "wall",
              color: _ctx.accentColor,
              "tooltip-text": "Center Brick",
              "tooltip-location": "start",
              onActivate: _ctx.goToBrickPosition
            }, null, 8, ["color", "onActivate"])
          ]),
          _hoisted_13,
          _hoisted_14,
          (!_ctx.showWebGL2Warning)
            ? (_openBlock(), _createBlock(_component_places_gallery, {
                key: 0,
                "stay-open": true,
                "places-list": _ctx.jwstPlaces,
                "alt-labels": ['with stars', 'no stars'],
                onSelect: _ctx.onGallerySelect,
                incomingItemSelect: _ctx.selectedGalleryItem,
                title: null,
                columns: "2",
                width: "200px",
                "prevent-deselect": "",
                style: {"box-shadow":"0px 0px 10px black"}
              }, {
                default: _withCtx(() => [
                  (_ctx.showJWSTOpacity)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          class: "opacity-range",
                          type: "range",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.crossfadeJWST) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.crossfadeJWST]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["places-list", "onSelect", "incomingItemSelect"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_v_btn, {
              style: {"pointer-events":"auto"},
              id: "overlay-button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showOverlay = !_ctx.showOverlay)),
              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.showOverlay = !_ctx.showOverlay), ["enter"])),
              tabindex: "0",
              color: _ctx.accentColor,
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.showOverlay ? `Hide` : `Show`) + " annotations ", 1)
              ]),
              _: 1
            }, 8, ["color"])
          ]),
          (_ctx.showLayers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.currentTool == 'crossfade')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", {
                          class: "ui-text slider-label",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.crossfadeOpacity = 0)),
                          onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.crossfadeOpacity = 0), ["enter"])),
                          tabindex: "0"
                        }, [
                          _createTextVNode("Spitzer"),
                          _hoisted_20,
                          _hoisted_21
                        ], 32),
                        _withDirectives(_createElementVNode("input", {
                          class: "opacity-range",
                          type: "range",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.crossfadeOpacity) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.crossfadeOpacity]
                        ]),
                        _createElementVNode("span", {
                          class: "ui-text slider-label",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.crossfadeOpacity = 100)),
                          onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.crossfadeOpacity = 100), ["enter"])),
                          tabindex: "0"
                        }, [
                          _createTextVNode("JWST"),
                          _hoisted_22,
                          _hoisted_23
                        ], 32)
                      ], 64))
                    : (_ctx.currentTool == 'choose-background')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_24,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.curBackgroundImagesetName) = $event))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backgroundImagesets, (bg) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: bg.imagesetName,
                                key: bg.imagesetName
                              }, _toDisplayString(bg.displayName), 9, _hoisted_25))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.curBackgroundImagesetName]
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa-grantee'] })
            ])
          ])
        ]),
        _createVNode(_component_v_dialog, {
          class: "error-dialog",
          style: _normalizeStyle(_ctx.cssVars),
          modelValue: _ctx.showWebGL2Warning,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showWebGL2Warning) = $event)),
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style", "modelValue"]),
        _createVNode(_component_v_dialog, {
          id: "video-container",
          modelValue: _ctx.showVideoSheet,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
          transition: "slide-y-transition",
          fullscreen: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_font_awesome_icon, {
                id: "video-close-icon",
                class: "close-icon",
                icon: "times",
                size: "lg",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showVideoSheet = false)),
                onKeyup: _cache[13] || (_cache[13] = _withKeys(($event: any) => (_ctx.showVideoSheet = false), ["enter"])),
                tabindex: "0"
              }),
              _hoisted_30
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          style: _normalizeStyle(_ctx.cssVars),
          class: "bottom-sheet",
          id: "text-bottom-sheet",
          "hide-overlay": "",
          persistent: "",
          "no-click-animation": "",
          absolute: "",
          width: "100%",
          scrim: false,
          location: "bottom",
          modelValue: _ctx.showTextSheet,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showTextSheet) = $event)),
          transition: "dialog-bottom-transition"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { height: "100%" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.tab) = $event)),
                  height: "32px",
                  color: _ctx.accentColor,
                  id: "tabs"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, {
                      class: "info-tabs",
                      tabindex: "0"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, {
                      class: "info-tabs",
                      tabindex: "0"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_font_awesome_icon, {
                      id: "close-text-icon",
                      class: "control-icon",
                      icon: "times",
                      size: "lg",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showTextSheet = false)),
                      onKeyup: _cache[16] || (_cache[16] = _withKeys(($event: any) => (_ctx.showTextSheet = false), ["enter"])),
                      tabindex: "0"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "color"]),
                _createVNode(_component_v_window, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.tab) = $event)),
                  id: "tab-items",
                  class: "pb-2 no-bottom-border-radius"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                              default: _withCtx(() => [
                                _hoisted_33,
                                _createElementVNode("p", null, [
                                  _createTextVNode("Our Milky Way galaxy is full of cold, dark clouds of gas and dust where new stars like our Sun are born. A cloud near the center of the galaxy, called “The Brick,” is possibly the "),
                                  _hoisted_34,
                                  _createTextVNode(" dark cloud in the entire Galaxy! Despite its large amount of mass, The Brick does not seem to be actively forming many new stars, so it remains dark and cold. A team of astronomers led by Adam Ginsburg observed The Brick using one of JWST’s near-infrared cameras. In the image, you can see many, many of the Milky Way’s stars in front of The Brick ("),
                                  _createElementVNode("a", {
                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.selectedGalleryItem=_ctx.jwstPlaces[0]))
                                  }, "left thumbnail"),
                                  _createTextVNode("). With some processing, the astronomers were able to remove the stars from the image and show only the cloud itself, revealing stripey structures and wisps in both the dark, cold gas and the hot, glowing background material ("),
                                  _createElementVNode("a", {
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.selectedGalleryItem=_ctx.jwstPlaces[1]))
                                  }, "right thumbnail"),
                                  _createTextVNode("). The ”blue” colors in the image ("),
                                  _createElementVNode("a", {
                                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.goToIcePosition()))
                                  }, "zoom in"),
                                  _createTextVNode(") show where frozen carbon monoxide, CO ice, is blocking out some of the light emitted by the hot glowing hydrogen that fills the Galactic Center.")
                                ]),
                                _hoisted_35,
                                _hoisted_36,
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _hoisted_37,
                                        _hoisted_38,
                                        _hoisted_39,
                                        _hoisted_40
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _hoisted_41,
                                        _createTextVNode(" Adam Ginsburg"),
                                        _hoisted_42,
                                        _createTextVNode(" Ashley Barnes"),
                                        _hoisted_43,
                                        _createTextVNode(" Cara Battersby"),
                                        _hoisted_44,
                                        _createTextVNode(" Alyssa Bulatek"),
                                        _hoisted_45,
                                        _createTextVNode(" Savannah Gramze"),
                                        _hoisted_46,
                                        _createTextVNode(" Jonathan Henshaw"),
                                        _hoisted_47,
                                        _createTextVNode(" Desmond Jeff"),
                                        _hoisted_48,
                                        _createTextVNode(" Xing Lu"),
                                        _hoisted_49,
                                        _createTextVNode(" E. A. C. Mills"),
                                        _hoisted_50,
                                        _createTextVNode(" Daniel Walker"),
                                        _hoisted_51,
                                        _hoisted_52
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_container, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { align: "center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_chip, {
                                              label: "",
                                              outlined: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Pan ")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "pt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "press + drag" : "click + drag"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "or") + " ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? ":" : "W-A-S-D"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "keys"), 1),
                                            _hoisted_53
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { align: "center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_chip, {
                                              label: "",
                                              outlined: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Zoom ")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "pt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "pinch in and out" : "scroll in and out"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "or") + " ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? ":" : "I-O"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "keys"), 1),
                                            _hoisted_54
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _hoisted_55,
                                            _hoisted_56
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_funding_acknowledgement),
                                            _createVNode(_component_v_spacer, { class: "end-spacer" })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style", "modelValue"]),
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_expand_transition, null, {
              default: _withCtx(() => [
                (_ctx.showRating)
                  ? (_openBlock(), _createBlock(_component_user_experience, {
                      key: 0,
                      question: _ctx.question,
                      "icon-size": "3x",
                      onDismiss: _cache[25] || (_cache[25] = (_rating, _comments) => {
            _ctx.showRating = false;
          }),
                      onRating: _cache[26] || (_cache[26] = (rating) => {
            _ctx.currentRating = rating;
            _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
          }),
                      onFinish: _cache[27] || (_cache[27] = (rating, comments) => {
            _ctx.currentRating = rating;
            _ctx.currentComments = comments;
            _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
            _ctx.showRating = false;
          })
                    }, {
                      footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_57, [
                          _createVNode(_component_v_btn, {
                            class: "rating-opt-put",
                            color: "#BDBDBD",
                            size: "small",
                            variant: "text",
                            onClick: _ctx.onOptOutClicked
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Don't show again ")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            class: "privacy-button",
                            color: "#BDBDBD",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showPrivacyPolicy = true)),
                            onKeyup: _cache[24] || (_cache[24] = _withKeys(($event: any) => (_ctx.showPrivacyPolicy = true), ["enter"])),
                            size: "small",
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" What is this? ")
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["question"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_cds_privacy_policy, {
              modelValue: _ctx.showPrivacyPolicy,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.showPrivacyPolicy) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}